import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIUserPermissionRsp } from '../../model';
import { PERMISSION_PREFIX } from '../config';

// 获取角色列表
export const getUserPermission = (
  studioID?: string,
  gameID?: string,
  envID?: number
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${PERMISSION_PREFIX}/user/permission`;
      const response = await api.commonRequest('GET', url, {
        studioID,
        gameID,
        guid: envID,
      });
      const res = await parsedResponse<IAPIUserPermissionRsp>(response, 'data');
      return res;
    } catch (error) {
      console.log(error);
      return null;
    }
  });
